// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2pMS-","requiredAsterisk":"Info_requiredAsterisk__3Hrhm"};